import {
  DocumentIcon,
  InformationCircleIcon,
} from '@heroicons/react/24/outline';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { Button } from '../../components/forms/Buttons/Button';
import { getApplicantsLite } from '../../services/application/application';
import { PassRules } from '../../utils/constants/rules';
import logo from '../../assets/images/biledu.png';
import ExportApplication from '../Students/StudentInfo/ExportApplication';

export default function ExportStudent() {
  const [t] = useTranslation();
  const { uuid } = useParams();

  const [studentInfo, setStudentInfo] = useState(null);

  useEffect(() => {
    console.log('uuid', uuid);

    if (uuid) {
      getApplicantsLite(uuid).then((res) => {
        setStudentInfo(res);
      });
    }

    return () => {};
  }, [uuid]);

  useEffect(() => {
    const meta = document.createElement('meta');
    meta.name = 'robots';
    meta.content = 'noindex, nofollow';
    document.head.appendChild(meta);

    return () => {
      document.head.removeChild(meta);
    };
  }, []);

  return (
    <div className='flex overflow-x-scroll bg-sheet p-8 lg:justify-center'>
      <ExportApplication studentInfo={studentInfo} />
    </div>
  );
}
